<template>
  <div class="bg-white rounded-lg shadow overflow-hidden">

    <div class="divide-y divide-gray-200 lg:grid lg:grid-cols-12 lg:divide-y-0 lg:divide-x">

      <aside class="mt-5 sm:mt-6 lg:col-span-3" v-if="regInProgress">
        <nav class="ml-5 mb-5  px-4 ">
          <ol role="list" class="overflow-hidden">
            <li v-for="(step, stepIdx) in steps" :key="step.name"
                :class="[stepIdx !== steps.length - 1 ? 'pb-10' : '', 'relative']">
              <template v-if="step.status === 'complete'">
                <div v-if="stepIdx !== steps.length - 1"
                     class="-ml-px absolute mt-0.5 top-4 left-4 w-0.5 h-full bg-primary-600" aria-hidden="true"/>
                <div class="relative flex items-start">
            <span class="h-9 flex items-center">
              <span
                  class="relative z-10 w-8 h-8 flex items-center justify-center bg-primary-600 rounded-full">
                <CheckIcon class="w-5 h-5 text-white" aria-hidden="true"/>
              </span>
            </span>
                  <span class="ml-4 min-w-0 flex flex-col">
              <span class="text-xs font-semibold tracking-wide uppercase">{{ step.name }}</span>
              <span class="text-sm text-gray-500">{{ step.description }}</span>
            </span>
                </div>
              </template>
              <template v-else-if="step.status === 'current'">
                <div v-if="stepIdx !== steps.length - 1"
                     class="-ml-px absolute mt-0.5 top-4 left-4 w-0.5 h-full bg-gray-300" aria-hidden="true"/>
                <div class="relative flex items-start" aria-current="step">
            <span class="h-9 flex items-center" aria-hidden="true">
              <span
                  class="relative z-10 w-8 h-8 flex items-center justify-center bg-white border-2 border-primary-600 rounded-full">
                <span class="h-2.5 w-2.5 bg-primary-600 rounded-full"/>
              </span>
            </span>
                  <span class="ml-4 min-w-0 flex flex-col">
              <span class="text-xs font-semibold tracking-wide uppercase text-primary-600">{{ step.name }}</span>
              <span class="text-sm text-gray-500">{{ step.description }}</span>
            </span>
                </div>
              </template>
              <template v-else>
                <div v-if="stepIdx !== steps.length - 1"
                     class="-ml-px absolute mt-0.5 top-4 left-4 w-0.5 h-full bg-gray-300" aria-hidden="true"/>
                <div class="relative flex items-start">
            <span class="h-9 flex items-center" aria-hidden="true">
              <span
                  class="relative z-10 w-8 h-8 flex items-center justify-center bg-white border-2 border-gray-300 rounded-full">
                <span class="h-2.5 w-2.5 bg-transparent rounded-full"/>
              </span>
            </span>
                  <span class="ml-4 min-w-0 flex flex-col">
              <span class="text-xs font-semibold tracking-wide uppercase text-gray-500">{{ step.name }}</span>
              <span class="text-sm text-gray-500">{{ step.description }}</span>
            </span>
                </div>
              </template>
            </li>
          </ol>
        </nav>


      </aside>
      <aside class="mt-5 lg:col-span-3" v-else>
        <nav>

          <!-- Current: "bg-teal-50 border-teal-500 text-teal-700 hover:bg-teal-50 hover:text-teal-700", Default: "border-transparent text-gray-900 hover:bg-gray-50 hover:text-gray-900" -->
          <router-link v-for="item in items" :key="item.url" :to="{name: item.name, params: {id: id}}"
                       :class="$route.name === item.name ? 'bg-primary-50 border-primary-500 text-primary-700' : 'border-transparent text-gray-900 hover:bg-gray-50 hover:text-gray-900'"
                       class="group border-l-4 px-3 py-2 flex items-center text-sm font-medium"
                       aria-current="page">
            <!-- Current: "text-teal-500 group-hover:text-teal-500", Default: "text-gray-400 group-hover:text-gray-500" -->
            <!-- <svg class="text-teal-500 group-hover:text-teal-500 flex-shrink-0 -ml-1 mr-3 h-6 w-6" fill="none" </svg> -->
            <component class="flex-shrink-0 -ml-1 mr-3 h-6 w-6 opacity-60" :is="item.icon"/>
            <span class="truncate"> {{ item.label }} </span>
          </router-link>

          <!--

                    <a href="#"
                       class="border-transparent text-gray-900 hover:bg-gray-50 hover:text-gray-900 group mt-1 border-l-4 px-3 py-2 flex items-center text-sm font-medium">
                      <svg class="text-gray-400 group-hover:text-gray-500 flex-shrink-0 -ml-1 mr-3 h-6 w-6" fill="none"
                           viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                              d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z"></path>
                      </svg>
                      <span class="truncate"> Пароль </span>
                    </a>


                    <a href="#"
                       class="border-transparent text-gray-900 hover:bg-gray-50 hover:text-gray-900 group mt-1 border-l-4 px-3 py-2 flex items-center text-sm font-medium">
                      <svg class="text-gray-400 group-hover:text-gray-500 flex-shrink-0 -ml-1 mr-3 h-6 w-6"
                           fill="none"
                           viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                              d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"></path>
                      </svg>
                      <span class="truncate"> Уведомления </span>
                    </a>


                    <a href="#"
                       class="border-transparent text-gray-900 hover:bg-gray-50 hover:text-gray-900 group mt-1 border-l-4 px-3 py-2 flex items-center text-sm font-medium">
                      <svg class="text-gray-400 group-hover:text-gray-500 flex-shrink-0 -ml-1 mr-3 h-6 w-6"
                           fill="none"
                           viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                              d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"></path>
                      </svg>
                      <span class="truncate">
                                    Мероприятия
                                  </span>
                    </a>
                    <a href="#"
                       class="border-transparent text-gray-900 hover:bg-gray-50 hover:text-gray-900 group mt-1 border-l-4 px-3 py-2 flex items-center text-sm font-medium">
                      <svg class="text-gray-400 group-hover:text-gray-500 flex-shrink-0 -ml-1 mr-3 h-6 w-6"
                           fill="none"
                           viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                              d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"></path>
                      </svg>
                      <span class="truncate">
                                    Оплата
                                  </span>
                    </a>
          -->

        </nav>
      </aside>

      <router-view/>
    </div>
  </div>
</template>

<script>

const menu_items = [
  {label: 'Профиль', 'icon': 'UserCircleIcon', 'name': 'UserProfile'},
  {label: 'Организации', 'icon': 'OfficeBuildingIcon', 'name': 'UserSchools'},
  {label: 'Пароль', 'icon': 'KeyIcon', 'name': 'UserPassword'},
  /*{label: 'Уведомления', 'icon': 'BellIcon', 'name': 'UserNotify'},*/
]
import {CheckIcon} from '@heroicons/vue/solid'
import {UserCircleIcon, KeyIcon, BellIcon, OfficeBuildingIcon} from '@heroicons/vue/outline'

export default {

  components: {UserCircleIcon, KeyIcon, BellIcon, OfficeBuildingIcon, CheckIcon},
  props: ['id'],
  setup() {
    return {
      menu_items,
    }
  },
  data() {
    return {
      items: menu_items,
    }
  },
  computed: {
    regInProgress() {
      return this.$store.getters['account/requiredName'] || this.$store.getters['school/requiredSchool'];
    },
    steps() {
      return [
        {
          id: '01', name: 'Регистрация',
          description: 'Введите электронную почту и пароль',
          status: 'complete'
        },
        {
          id: '02', name: 'Личная информация',
          description: 'Укажите фамилию и имя',
          status: this.$store.getters['account/requiredName'] ? 'current' : 'complete'
        },
        {
          id: '03', name: 'Организация',
          description: 'Добавьте вашу учебную организацию',
          status: this.$store.getters['account/requiredName'] ? 'upcoming' : 'current'
        },
      ]
    }
  }

}
</script>

<style scoped>

</style>